<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="/" class="footer-link">wagbapks.id</a>. WA GB adalah aplikasi modifikasi pihak ketiga dan bukan produk resmi WhatsApp atau Meta.</p>
    </div>
    <div class="footer-links">
      <a href="/about-us/" class="footer-link">Tentang</a>
      <a href="/contact-us/" class="footer-link">Kontak</a>
      <a href="/privacy-policy/" class="footer-link">Privasi</a>
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      <a href="/terms-and-conditions/" class="footer-link">Ketentuan</a>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 16px 0;
  border-top: 1px solid #e8eeee;
}

.footer-container {
  width: min(1080px, calc(100% - 32px));
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.footer-link {
  color: #117867;
  text-decoration: none;
  font-size: 0.96rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #0b7468;
}

.footer-note {
  max-width: 620px;
  font-size: 14px;

  p {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 14px 0 58px;
  }

  .footer-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-note {
    font-size: 12px;
  }
}
</style>
